import HttpService from "./htttp.service";

class HistoryService {
    /**
     * Fetch the history of metrics for a specific post.
     * @param {String} profileId - The internal Profile ID
     * @param {String} postId - The original post ID (from the platform)
     * @param {String} platform - The platform name (facebook, instagram, youtube)
     * @returns {Promise<Array>} - Array of history objects { metrics, snapshotDate }
     */
    async fetchPostHistory(profileId, postId, platform = "facebook") {
        // Standardize platform to lowercase for the URL
        const platformKey = platform.toLowerCase();

        // Ensure we handle video vs post terminology if needed by the backend, 
        // but usually the backend route can be generic or specific.
        // The planned route is /platform/:platformName/:profileId/post/:postId/history

        // Note: The backend implementation plan suggested:
        // GET /platform/facebook/:id/post/:postId/history
        // So we will construct the URL dynamically.

        const url = `platform/${platformKey}/${profileId}/post/${postId}/history`;
        console.log(`[Frontend HistoryService] Fetching URL: ${url}`);
        return HttpService.get(url);
    }
}

export const historyService = new HistoryService();
